import React from 'react'
import './About.css'
import Skill from './Skill'
const About = () => {
    return(
        <React.Fragment>
            <div className="abt-wrap">
                <h1><u>About Me</u>😙</h1>
                <div className="first">
                    <div className="abt-left">
                        <p><b>Energetic and Inovative</b>, learning from the basic root and slowly gear up my profile to compete with others and also keen to learn new things. I also made proficiency in programming languages like C++, Python & C. I am also interested in competitive programming and possess a moderate command over Data Structures & Algorithms.</p>
                        <div className="abt-btn-wrap">
                            <a className="abt-btn-1" href="https://docs.google.com/document/d/1Ps-0VMn3s7dWucfyUvYWlAbf3C7xBEki/edit"><i className="fa fa-download"></i> Download CV</a>
                        </div>
                    </div>
                    
                    <div className="abt-right">
                        <img src="assets/sd.jpeg" alt="sd"/>
                    </div>
                </div>
                <div className="second">
                    <h2>Available for Internships ...</h2>
                    <div className="abt-icon-wrap">
                        <a href="https://github.com/Soham2020"><i className="fa fa-2px fa-github"></i></a>
                        <a href="www.linkedin.com/in/soham-das-2a0467190"><i className="fa fa-2px fa-linkedin"></i></a>
                        <a href="https://www.instagram.com/soham5451/"><i className="fa fa-2px fa-instagram"></i></a>                        
                    </div>
                    <Skill/>
                </div>
                <div className="third">
                    <div className="abt-right">
                        <img src="assets/about.gif" alt="about" style={{width: '280px'}} />
                    </div>
                    <div className="abt-left">
                        <p>Currently, I am completing my B.Tech degree from B.P.PODDAR INSTITUTE OF MANAGEMENT AND TECHNOLOGY affiliated to MAKAUT University. As a Second year student, I don't know that I am a good or bad programmer and web developer, but I am trying my best to learn more and more skills because I love to explore new things and do different types of experiments with all these new stuffs to create something new and which will be more creative. And my followers and followings will help me to gain my knowledge in this field. Hope we together, will do lots of new things and also explore.<br/><b>Let's Explore</b></p>        
                    </div>
                    
                </div>
                
            </div>
            {/* <h1 className="skill-header">My Comfort Zone's</h1>
            <div className="skill-pic">
                <img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png" style={{width: '70px'}} alt="html"/>   
                <img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png" style={{width: '70px'}} alt="css"/>
                <img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/bootstrap/bootstrap.png" style={{width: '70px'}} alt="bootstrap" />
                <img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/sass/sass.png" style={{width: '70px'}} alt="sass" />
                <img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png" style={{width: '70px'}} alt="js" />
                <img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/visual-studio-code/visual-studio-code.png" style={{width: '70px'}} alt="vsc"/>
                <img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/react/react.png" style={{width: '70px'}} alt="react"/>
            </div> */}
            
        </React.Fragment>
    )
}
export default About;